/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
var ModalColor = /*#__PURE__*/function (ModalColor) {
  ModalColor["Neutral"] = "neutral";
  ModalColor["Warning"] = "warning";
  ModalColor["Critical"] = "critical";
  return ModalColor;
}(ModalColor || {});
var ModalSize = /*#__PURE__*/function (ModalSize) {
  ModalSize["Small"] = "small";
  ModalSize["Medium"] = "medium";
  ModalSize["Large"] = "large";
  return ModalSize;
}(ModalSize || {});
export default class ModalComponent extends Component {}